import AddColumns from './AddColumns/AddColumns';
import SelectedColumns from './SelectedColumns/SelectedColumns';

interface IAttributesProps {
    className?: string;
    selectedColumns: string[];
    setSelectedColumns: (columns: string[]) => void;
    permanentColumns?: string[];
}
const Attributes = ({
    className,
    selectedColumns,
    setSelectedColumns,
    permanentColumns,
}: IAttributesProps) => (
    <div className={`Attributes d-flex flex-column ${className}`}>
        <SelectedColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} permanentColumns={permanentColumns} />
        <hr />
        <AddColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} />
    </div>
);

export default Attributes;
